let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("g5eT1")).then(() => parcelRequire('e9W1F'));